module.exports = __webpack_public_path__ + "img/WP1_IronSword.cd31b36e.png";